/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_preview_alert_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `This is a preview`
};

const fr_preview_alert_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `Ceci est un aperçu`
};

const de_preview_alert_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `Dies ist eine Vorschau`
};

const es_preview_alert_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `Esta es una vista previa`
};

const it_preview_alert_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `Questa è un'anteprima`
};

const ar_preview_alert_title17 = /** @type {(inputs: {}) => string} */ () => {
	return `هذه معاينة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const preview_alert_title17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.preview_alert_title17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("preview_alert_title17", locale)
	if (locale === "en") return en_preview_alert_title17(inputs)
	if (locale === "fr") return fr_preview_alert_title17(inputs)
	if (locale === "de") return de_preview_alert_title17(inputs)
	if (locale === "es") return es_preview_alert_title17(inputs)
	if (locale === "it") return it_preview_alert_title17(inputs)
	return ar_preview_alert_title17(inputs)
};
export { preview_alert_title17 as "PREVIEW_ALERT_TITLE" }